import { render, staticRenderFns } from "./blog_list.vue?vue&type=template&id=8572ee04"
import script from "./blog_list.vue?vue&type=script&lang=js"
export * from "./blog_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports